import React, { useEffect, useState, createContext } from 'react';
import { getAndroidEnterprise } from './settings/android/enterprise/AndroidEnterpriseApiService'

export let AndroidEnterpriseContext = createContext();

export default function Contexts({ children }) {

    let [ androidEnterprise, setAndroidEnterprise ] = useState(undefined);
    let [ loading, setLoading] = useState(true)

    useEffect(initialAppLevelData, [])

    function initialAppLevelData() {
        getAndroidEnterprise((androidEnterprise) => {
            setAndroidEnterprise(androidEnterprise)
            setLoading(false)
        }, () => {
            setAndroidEnterprise(undefined)
            setLoading(false)
        })
    }

    return (
        <AndroidEnterpriseContext.Provider value={{ androidEnterprise, setAndroidEnterprise, loading }}>
            {children}
        </AndroidEnterpriseContext.Provider>
    )
}